import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import logoSrc from '../../../assets/images/logo-full-white.webp';
import bgSrcMob from '../../../assets/images/bg-mobile@2x.png';
import bgSrcDeskt from '../../../assets/images/bg@2x.png';
import icon from '../../../assets/favicon.ico';
import './authLayout.scss';
import constants from '../../../core/constants';
import { LayoutProps } from './types';

const { APP_NAME } = constants;

const AuthLayout:FC<LayoutProps> = ({ children }) => (
    <div className="login-wrap">
        <Helmet
            title={`${APP_NAME}`}
            titleTemplate={`${APP_NAME}`}
            defaultTitle={`${APP_NAME}`}
            meta={[
                { name: 'description', content: `${APP_NAME} website` },
                { property: 'og:type', content: 'website' },
            ]}>
            <link rel="shortcut icon" href={icon} />
        </Helmet>
        <div className="login-info">
            <div className="bg-absolute">
                <picture>
                    <source srcSet={bgSrcDeskt} media="(min-width: 768px)" />
                    <img src={bgSrcMob} alt={`${APP_NAME}`} />
                </picture>
            </div>
            <div className="login-info__text">
                <img src={logoSrc} alt="logo" className="main-logo" />
                <h2 className="title">Sveiki atvykę į Šiaulių savivaldybės švietimo įstaigų veiklos kokybės stebėsenos informacinę sistemą</h2>
                <div className="login-info__copyright">
                    <div className="login-info__copyright-main">
                        <span className="login-info__copyright-line" />
                        <span className="login-info__copyright-title">
                            © 2026 Šiaulių švietimo kompetencijų centras.
                        </span>
                        <span className="login-info__copyright-line" />
                    </div>
                    <p className="login-info__copyright-subtitle">
                        Visos teisės saugomos.
                    </p>
                    <p className="login-info__copyright-text">
                        VKSIS (Veiklos kokybės stebėsenos informacinė sistema), jos struktūra, dizainas, duomenų apdorojimo sprendimai ir
                        turinys yra saugomi autorių teisių. Be raštiško teisių turėtojo leidimo draudžiama sistemą kopijuoti, platinti,
                        modifikuoti ar naudoti komerciniais tikslais.
                    </p>
                </div>
            </div>
        </div>
        {children}
    </div>
);

export default AuthLayout;
